import { getStore, setStore } from "@/utils/store";
import {
  loginByMobile,
  loginByUsername,
  getUserInfo,
  logout,
  refreshToken,
  getUserInfoByToken,
} from "@/api/login";
import { encryption } from "@/utils";

const user = {
  state: {
    userName:
      getStore({
        name: "user_name",
      }) || "",
    userInfo:
      getStore({
        name: "userInfo",
      }) || {},
    access_token:
      getStore({
        name: "access_token",
      }) || "",
    refresh_token:
      getStore({
        name: "refresh_token",
      }) || "",
    tenantId:
      getStore({
        name: "tenantId",
      }) || "",
    tenantName:
      getStore({
        name: "tenantName",  
      }) || "",
    userId:
      getStore({
        name: "userId",
      }) || "",
    isAdminTenant:
      getStore({
        name: "isAdminTenant",
      }) || "",
  },
  actions: {
    // 根据用户名登录
    LoginByUsername({ commit }, userInfo) {
      const user = encryption({
        data: userInfo,
        key: "pigxpigxpigxpigx",
        param: ["password"],
      });
      return new Promise((resolve, reject) => {
        loginByUsername(user.username, user.password, user.code, user.randomStr)
          .then((response) => {
            const data = response.data.data;
            commit("SET_ACCESS_TOKEN", data.access_token);
            commit("SET_USER_NAME", user.username);
            commit("SET_REFRESH_TOKEN", data.refresh_token);
            commit("CLEAR_LOCK");
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 刷新token
    RefreshToken({ commit, state }) {
      return new Promise((resolve, reject) => {
        refreshToken(state.refresh_token)
          .then((response) => {
            const data = response.data;
            commit("SET_ACCESS_TOKEN", data.access_token);
            commit("SET_REFRESH_TOKEN", data.refresh_token);
            commit("CLEAR_LOCK");
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 根据手机号登录
    LoginByPhone({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        loginByMobile(userInfo.mobile, userInfo.code)
          .then((response) => {
            const data = response.data.data;
            commit("SET_ACCESS_TOKEN", data.access_token);
            commit("SET_REFRESH_TOKEN", data.refresh_token);
            commit("CLEAR_LOCK");
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 查询用户信息
    GetUserInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getUserInfo(state.userName)
          .then((res) => {
            const data = res.data.data || {};
            const companyId = data.companyId || "";
            const factoryId = data.factoryId || "";
            const shopId = data.shopId || "";
            const tenantId = data.tenantId || "";
            const terminalType = data.terminalType; // 标识，判断账号是否登录正确的平台
            const loginLimit = data.loginLimit; // 标识，判断账号是否首次登录
            const organizeName = data.organizeName; // 租户
            const roleCode = data.roleCode;
            const tenantType = data.tenantType;
            const userInfo = {
              ...data.sysUser,
              companyId,
              factoryId,
              shopId,
              terminalType,
              loginLimit,
              tenantId,
              organizeName,
              roleCode,
              tenantType,
            };
            commit("SET_USER_INFO", userInfo);
            commit("SET_USER_ID", userInfo.userId);
            resolve(data);
          })
          .catch(() => {
            reject();
          });
      });
    },
    // 通过token拿取个人信息
    GetUserInfoByToken({ commit }) {
      return new Promise((resolve, reject) => {
        getUserInfoByToken()
          .then((res) => {
            const data = res.data.data || {};
            const companyId = data.companyId || "";
            const factoryId = data.factoryId || "";
            const shopId = data.shopId || "";
            const tenantId = data.tenantId || "";
            const terminalType = data.terminalType || null; // 标识，判断账号是否登录正确的平台
            const loginLimit = data.loginLimit; // 标识，判断账号是否首次登录
            const organizeName = data.organizeName; // 租户
            const roleCode = data.roleCode;
            const userInfo = {
              ...data.sysUser,
              companyId,
              factoryId,
              shopId,
              terminalType,
              loginLimit,
              tenantId,
              organizeName,
              roleCode,
            };
            commit("SET_USER_INFO", userInfo);
            commit("SET_USER_ID", userInfo.userId);
            commit("SET_USER_NAME", userInfo.username);
            resolve(data);
          })
          .catch(() => {
            reject();
          });
      });
    },
    // 登出
    LogOut({ commit }) {
      return new Promise((resolve, reject) => {
        logout()
          .then(() => {
            commit("SET_USER_INFO", {});
            commit("CLEAR_LOCK");
            commit("SET_ACCESS_TOKEN", "");
            commit("SET_REFRESH_TOKEN", "");
            commit("SET_TENANT_ID", ""); // 清除tenantId
            commit("SET_TENANT_NAME", "");
            commit("SET_USER_NAME", ""); // 清除username
            commit("SET_USER_ID", ""); // 清除userId
            commit("SET_IS_ADMIN_TENANT", "");
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
  mutations: {
    SET_ACCESS_TOKEN: (state, access_token) => {
      state.access_token = access_token;
      setStore({
        name: "access_token",
        content: state.access_token,
        type: "session",
      });
    },
    SET_USER_NAME: (state, userName) => {
      state.userName = userName;
      setStore({
        name: "user_name",
        content: state.userName,
        type: "session",
      });
    },
    SET_REFRESH_TOKEN: (state, rfToken) => {
      state.refresh_token = rfToken;
      setStore({
        name: "refresh_token",
        content: state.refresh_token,
        type: "session",
      });
    },
    SET_USER_INFO: (state, userInfo) => {
      state.userInfo = userInfo;
      setStore({
        name: "userInfo",
        content: userInfo,
        type: "session",
      });
    },
    SET_TENANT_ID: (state, tenantId) => {
      state.tenantId = tenantId;
      setStore({
        name: "tenantId",
        content: tenantId,
        type: "session",
      });
    },
    SET_TENANT_NAME: (state, tenantName) => {
      state.tenantName = tenantName;
      setStore({
        name: "tenantName",
        content: tenantName,
        type: "session",
      });
    },
    SET_USER_ID: (state, userId) => {
      state.userId = userId;
      setStore({
        name: "userId",
        content: userId,
        type: "session",
      });
    },
    SET_IS_ADMIN_TENANT: (state, isAdminTenant) => {
      state.isAdminTenant = isAdminTenant;
      setStore({
        name: "isAdminTenant",
        content: isAdminTenant,
        type: "session",
      }); 
    }
  },
};
export default user;
